//replaces large-single-number.html
import { dynamicFilterFilter } from "app/filters/dynamicFilter";
import type { FC } from "react";

interface ILargeSingleNumberCellTemplate {
    data: any;
    row: any;
}
export const LargeSingleNumberCellTemplateV2: FC<ILargeSingleNumberCellTemplate> = (props) => {
    const { data, row } = props;

    return (
        <div className="u-blueMediumMedium large-single-number">
            {dynamicFilterFilter()(data[row.field], row.format)}
        </div>
    );
};
